import { render, staticRenderFns } from "./SessionManagementConfig.vue?vue&type=template&id=46a4df96"
import script from "./SessionManagementConfig.vue?vue&type=script&lang=js"
export * from "./SessionManagementConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports